// extracted by mini-css-extract-plugin
module.exports = {"myScrollbar":"Calendar_myScrollbar__1NbXx","wrapper":"Calendar_wrapper__1yCGF","header":"Calendar_header__12oIX","cell":"Calendar_cell__14YNP"};